import React, { useEffect, useState } from "react";

import { RoundedButton } from "@greeter/matter";
import { Accordion, AccordionProps } from "@greeter-venue/components/Accordion";

import css from "./SelectAccordion.module.scss";

export type SelectValue<T> = {
  text: string;
  value: T;
};

export type SelectAccordionProps<T> = Pick<AccordionProps, "title"> & {
  values: SelectValue<T>[];
  selectedValues?: T[];
  onSelect?: (selectedValues: T[]) => void;
  selectedComparer?: (a: T, b: T) => boolean;
};

export function SelectAccordion<T>({
  values,
  selectedValues = [],
  onSelect,
  selectedComparer: selectComparer = (a, b) => a === b,
  ...props
}: SelectAccordionProps<T>) {
  const [_selectedValues, setSelectedValues] = useState<T[]>(selectedValues);

  useEffect(() => {
    if (onSelect) onSelect(_selectedValues);
  }, [_selectedValues, onSelect]);

  useEffect(() => {
    setSelectedValues(selectedValues);
  }, [selectedValues]);

  return (
    <Accordion {...props}>
      <div className={css.Container}>
        {values.map((v) => {
          return (
            <RoundedButton
              className={css.RoundedButton}
              activeClassName={css.Active}
              onClick={() =>
                setSelectedValues(
                  _selectedValues.find((s) => selectComparer(v.value, s))
                    ? _selectedValues.filter((s) => !selectComparer(v.value, s))
                    : [..._selectedValues, v.value]
                )
              }
              active={!!_selectedValues.find((s) => selectComparer(v.value, s))}
            >
              {v.text}
            </RoundedButton>
          );
        })}
      </div>
    </Accordion>
  );
}
